import {
  useCookieStore,
  useNavigationStore,
  useServiceTreeStore,
} from '@packages/shared';
import { posthog } from 'posthog-js';
const activeServiceShortIds = ['consultation-choose-doctor'];

export const useIsChooseDoctorFlow = () => {
  const { serviceShortId } = useNavigationStore((s) => ({
    serviceShortId: s.queries.service,
  }));
  const getServiceByShortId = useServiceTreeStore((s) => s.getServiceByShortId);
  const service = serviceShortId
    ? getServiceByShortId(serviceShortId)
    : undefined;
  const isChooseDoctorService = activeServiceShortIds.includes(
    service?.shortId ?? '',
  );

  //Feature flag
  const isPosthogEnabled = useCookieStore((s) => s.isPosthogEnabled);
  const isEnabled =
    isPosthogEnabled && posthog?.getFeatureFlag('choose-doctor-v2') === 'test';

  return isChooseDoctorService && isEnabled;
};
